export const heroData = {
    title: 'The first modular blockchain network',
    text: 'Hash Protocol is a modular consensus and data network, built to enable anyone to easily deploy their own blockchain with minimal overhead.',
    buttons:[
            {
                text: 'See the roadmap',
                class: 'simple',
                type: 'internal',
                url: '#roadmap'
            },
            {
                text: 'Join the community',
                class: 'white',
                type: 'internal',
                url: '#join-the-community'
            }
        ]
}

